import {Component, ElementRef, Input, OnInit, Renderer, ViewChild} from '@angular/core';
import {TranslateService} from "../../shared/translate.service";
import {Toast} from "../../dialog/alert/toastr/toast";
import {ToastType} from "../../dialog/alert/toastr/toast-type.enum";
import {MessageService} from "../../messages/message.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {FeedbackModel} from "./feedback.model";
import {environment} from "../../../environments/environment";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {HtmlUtilsService} from "../../html-utils/html-utils.service";
import {AuthService} from '../../auth/auth.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  @ViewChild('modal') modal: ElementRef;

  @ViewChild('agreementDiv') agreementDiv: ElementRef;

  private captchaSuccess: boolean;

  typeSelect = new FormControl(')');
  email = new FormControl('', [Validators.required, Validators.email]);
  rate = new FormControl('brak');
  message = new FormControl('', [Validators.required, Validators.maxLength(2000)]);
  aggrement = new FormControl('', Validators.requiredTrue);

  aFormGroup: FormGroup;

  type: string;

  typeOptions: string[];

  editableEmail = true;

  formInvalid = false;

  constructor(public translator: TranslateService,
              private messageService: MessageService,
              private formBuilder: FormBuilder,
              private http: HttpClient,
              public activeModal: NgbActiveModal,
              private renderer: Renderer,
              public htmlUtils: HtmlUtilsService,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.typeOptions = [];
    this.typeOptions.push(this.translator.translate('FeedbackComponent.OPINION'));
    this.typeOptions.push(this.translator.translate('FeedbackComponent.BUG'));

    this.aFormGroup = this.formBuilder.group({    });

    this.typeSelect.setValue(this.translator.translate(`FeedbackComponent.${this.type}`));
    this.rate.setValue('brak');
    if (this.authService.isLogged.value) {
      this.email.setValue(this.authService.currentUserValue.email);
      this.editableEmail = false;
    }
  }

  send(): void {

    if (this.aFormGroup.valid && this.email.valid && this.rate.valid && this.message.valid && this.aggrement.valid) {
        let value = this.rate.value;
        let feedbackModel = new FeedbackModel(this.typeSelect.value, this.email.value, window.location.href, window.location.href, value === 'brak' ? null : value, this.message.value);
        this.http.post('portalApiUrl/omnis/portal/feedback', feedbackModel).subscribe(result => {
          this.formInvalid = false;
          if (result) {
            this.messageService.add(new Toast(this.translator.translate('FeedbackComponent.accept.title'), this.translator.translate('FeedbackComponent.accept.message'), ToastType.SUCCESS));
            this.activeModal.close();
          } else {
            this.messageService.add(new Toast('Błąd', 'Bład podczas wysyłania opini', ToastType.ERROR));
          }
        });
    } else {
      this.formInvalid = true;
      this.messageService.add(new Toast('Uzupełnij pola', 'Nie wszystkie pola zostały uzupełnione', ToastType.INFO));
    }
  }

  getText(key: string): string {
    return this.translator.translate(key);
  }

  isSelected(name: string): string {
    if (name === this.translator.translate(`FeedbackComponent.${this.type}`)) {
      return "true";
    } else {
      return null;
    }
  }

  highContrast() {
    this.htmlUtils.highContrast.subscribe(value => {
      if (value) {
        this.addContrastToMessage();
        this.addContrastToCaptcha();
      } else {
        this.removeContrastFromMessage();
        this.removeConstrastFromCaptcha();
      }
    });
    if (this.htmlUtils.contrast) {
      this.addContrastToMessage();
      this.addContrastToCaptcha();
    }

  }

  private removeConstrastFromCaptcha() {

  }

  private removeContrastFromMessage() {
    document.getElementsByClassName('rc-anchor rc-anchor-normal rc-anchor-light')[0].classList.remove('contrast');
  }

  private addContrastToCaptcha() {

  }

  private addContrastToMessage() {
    document.getElementById('message').classList.add('contrast');
  }

  captchaSuccessChanged($event) {
    this.captchaSuccess = $event;
  }
}
